import { allCountries } from 'models/utils/countries';

export const SegmentationOptions = [
  {
    category: 'acquisition',
    children: [
      {
        category: 'url',
        operators: ['matches', 'does_not_match', 'contains', 'does_not_contain', 'ends_with', 'starts_with'],
        defaultOperator: 'matches',
      },
    ],
  },
  {
    category: 'behaviour',
    children: [
      {
        category: 'visitorLoggedIn',
        values: ['true', 'false'],
        defaultValue: 'true',
      },
    ],
  },
  {
    category: 'eCommerce',
    children: [
      {
        category: 'basket',
        children: [
          {
            category: 'basketContainsItems',
            values: ['true', 'false'],
            defaultValue: 'true',
          },
          {
            category: 'basketSource',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
          {
            category: 'basketType',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'number',
            defaultValue: '',
          },
          {
            category: 'basketValue',
            operators: [
              'is_greater_than',
              'is_greater_than_or_equal_to',
              'is_equal_to',
              'is_less_than_or_equal_to',
              'is_less_than',
            ],
            defaultOperator: 'is_greater_than',
            filterType: 'numeric',
            defaultValue: '',
          },
          {
            category: 'repopulationUrl',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
          {
            category: 'shippingCountry',
            operators: ['is', 'is_not'],
            defaultOperator: 'is',
            values: Object.keys(allCountries),
            defaultValue: 'GB',
          },
        ],
      },
      {
        category: 'stock',
        children: [
          {
            category: 'itemCategory',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
          {
            category: 'itemId',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
          {
            category: 'itemInStock',
            values: ['true', 'false'],
            defaultValue: 'true',
          },
          {
            category: 'itemLowStock',
            values: ['true', 'false'],
            defaultValue: 'true',
          },
          {
            category: 'itemName',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
          {
            category: 'itemUrl',
            operators: ['is', 'is_not', 'includes', 'does_not_include'],
            defaultOperator: 'is',
            filterType: 'string',
            defaultValue: '',
          },
        ],
      },
    ],
  },

  {
    category: 'geography',
    children: [
      {
        category: 'geoLocation',
        operators: ['is', 'is_not'],
        values: Object.keys(allCountries),
        defaultOperator: 'is',
        defaultValue: 'GB',
      },
    ],
  },
  {
    category: 'sectionLegacy',
    children: [
      {
        category: 'legacy',
        operators: ['is', 'is_not', 'includes', 'does_not_include'],
        defaultOperator: 'is',
        filterType: 'string',
        defaultValue: '',
      },
    ],
  },
  {
    category: 'technology',
    children: [
      {
        category: 'deviceType',
        operators: ['is', 'is_not'],
        values: ['mobile', 'desktop'],
        defaultOperator: 'is',
        defaultValue: 'mobile',
      },
    ],
  },
];
